module.exports = __webpack_public_path__ + "assets/img/ba0a51526140545da84f1a95723ace45.svg";